/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {relinkInstrumentLink} from '../api'

export const useMutationRelinkInstrumentLink = createReactQueryMutationHook('relinkInstrumentLink', relinkInstrumentLink)
